// extracted by mini-css-extract-plugin
module.exports = {"footer":"CreateHouseholdsForm-module__footer--1H3O8","formField":"CreateHouseholdsForm-module__formField--1jl1f"};